<template>
    <div>
            <div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">{{$t('3310')}}</div>
            <div class="divider"></div>
            <!-- subtabs -->
            
            <div v-if="campaignData && campaignData.locationValue === '0'" class="container mgt-30">
                <a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank" class="d-block">
                    <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" class="b-radius4 list-banner-img">
                </a>
                <a v-else href="javascript:void(0)" style="cursor:none" class="b-radius4 list-banner-img d-block">
                    <img :src="campaignData.image" alt="">
                </a>
            </div>
            
            <NoData v-if="isNoData"></NoData>

            <div class="container">
                <div class="d-flex justify-content-between align-items-baseline mgt-30 mgb-16">
                    <div class="t-color-headlineBlack t-headline10 font-b">{{$route.query.name}}</div>
                    <!-- <div class="t-color-secondaryBtnText t-body2 font-m">모두 보기</div> -->
                </div>

                <template v-for="(degree, index) in listData"  >
                    <div v-if="campaignData && parseInt(campaignData.locationValue) === index+1"  class="" :key="index" >
                        <a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink?campaignData.dynamicLink.shortLink:''" target="_blank">
                            <img :src="campaignData.image" alt="">
                        </a>
                        <a v-else href="javascript:void(0)" style="cursor:none">
                            <img :src="campaignData.image" class="">
                        </a>

                    </div>
                    <CardItem2 :degree="degree" :type="type" :key="index" ></CardItem2>

                    

                </template>
                              
                
            </div>
            <infinite-loading @infinite="fetchData" spinner="spiral">
                    <div slot="no-more" class="pdt-10 pdb-10"></div>
                    <!-- <div slot="no-more" class="pdt-10 pdb-10">No more data</div> -->
                    <div slot="no-results" class="pdt-10 pdb-10"></div>
                </infinite-loading>

        </div>
   
</template>

<script>

/**
 * 카테고리별 차수 리스트 컴포넌트(category degree list Component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import InfiniteLoading from 'vue-infinite-loading'
import degreeApi from '@/api/degreeApi.js'
import campaignApi from '@/api/campaignApi.js'
import CardItem2 from '@/components/degree/list/CardItem2.vue'
import NoData from '@/components/common/NoDataDegree.vue'

export default {
    components: {
        CardItem2, NoData, InfiniteLoading
    },

    data() {
        return {
            campaignData: null,
            isNoData: false,
            listData: [],
            currentPage: 1,
            totalPages: 1,
            type:'category'
        }
    },
  
    methods: {
        // 목록 데이터 호출(call api list data)
        fetchData($state) {
            let responseData = null
            let userIds = null
            let params = this.memberDetail ? this.setParams() : this.setParmasNoLogin()
            userIds =  localStorage.getItem("token")

          if (this.totalPages >= this.currentPage) {
                degreeApi.learnOnlineList(params).then((response) => {

                    responseData = response.data.data
                    //console.log(responseData)

                    this.listData = this.listData.concat(responseData.content)
                    this.currentPage++
                    this.totalPages = responseData.totalPages

                    if (responseData.content.length) {
                        $state.loaded()
                    } else {
                        $state.complete()
                    }

                    if (!this.listData.length) {
                      this.isNoData = true
                    }
                }).catch((err) => {})
            } else {
                $state.complete()
            }

            // 캠페인 테이터 API 호출(call api campaign data)
            let locationType = 'CATEGORY_DEGREE'
            campaignApi.campaign({locationType: locationType}).then((response) => {
                //console.log('campaign response.data.data', response.data.data);
                this.campaignData = response.data.data
                
            }).catch((err) => {})
        },

        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                page: this.currentPage,
                size: 10,
                category: this.$route.query.id,
                sort: 'groupId,desc'
            }
            return params
        },
      setParmasNoLogin() {
        const params = {
          page: this.currentPage,
          size: 10,
          category: this.$route.query.id,
          sort: 'id,desc'
        }
        return params
      }
    }


}
</script>
